export default {
    auth: {
        foreigner_wrapper: "Sou estrangeiro / I'm a foreigner",
    },
    login: {
        title_wrapper: {
            title: 'Acesse sua conta',
            description: 'Bem vindo de volta! Entre com seus dados.',
        },
        text_inputs_wrapper: {
            input_item: {
                cpf_label: 'CPF ou CNPJ',
                cpf_placeholder: 'Digite seu documento',
                password_label: 'Senha',
                password_placeholder: 'Digite sua senha',
                forgot_password: 'Esqueceu a senha?',
            },
        },
        error_column: {
            api_error: '{{errorMessage}}',
        },
        big_button: {
            submit_text: 'Fazer Login',
        },
        create_account_notice: {
            text: 'Não tem uma conta ainda?',
            link_text: 'Criar conta',
        },
        maintenance: {
            title: 'Manutenção em andamento',
            summary:
                'O login está temporariamente indisponível enquanto finalizamos novidades.',
            toast_full:
                'Estamos na fase final de liberação do calendário de reservas da hotelaria.\nA loja será disponibilizada nas próximas horas com as novas funcionalidades.\nAgradecemos a compreensão.',
        },
    },
    reset_password: {
        title_wrapper: {
            title: 'Recuperar senha',
            description: 'Informe seu documento para seguir.',
        },
        text_inputs_wrapper: {
            input_item: {
                cpf_label: 'CPF ou CNPJ',
                cpf_placeholder: 'Digite seu documento',
            },
        },
        error_column: {
            api_error: '{{errorMessage}}',
        },
        big_button: {
            submit_text: 'Confirmar',
        },
        create_account_notice: {
            text: 'Já tem uma conta?',
            link_text: 'Fazer login',
        },
    },
    create_account: {
        title_wrapper: {
            title: 'Crie sua conta',
            description: 'Insira seus dados para completar o cadastro.',
        },
        text_inputs_wrapper: {
            name_label: 'Nome',
            name_placeholder: 'Digite seu nome',
            bornDate_label: 'Data de nascimento',
            bornDate_placeholder: '00/00/0000',
            email_label: 'E-mail',
            email_placeholder: 'Digite seu e-mail',
            cpf_label: 'CPF ou CNPJ',
            cpf_placeholder: 'Digite seu documento',
            phone_label: 'Telefone',
            phone_placeholder: 'Telefone',
            password_label: 'Senha',
            password_placeholder: 'Digite sua senha',
            confirm_password_label: 'Confirmar senha',
            confirm_password_placeholder: 'Digite sua senha',
            cep_label: "CEP",
            address_label: "Endereço",
            cep_placeholder: "Digite seu CEP",
        },
        error_column: {
            api_error: '{{errorMessage}}',
        },
        big_button: {
            submit_text: 'Cadastrar',
        },
        create_account_notice: {
            text: 'Já tem uma conta?',
            link_text: 'Fazer login',
        },
    },
    check_email_confirmation: {
        title_wrapper: {
            title: 'Verifique seu e-mail!',
            description:
                'Enviamos as instruções para recuperação da sua senha.',
        },
        big_button: {
            submit_text: 'Voltar para o login',
        },
    },
};
